import axios from '../axios';
const END_POINT = '/auth';

const login = (payload) => {
    // const formData = new FormData();
    // for(const key in payload){
    //     formData.append(key,payload[key])
    // }
    return axios.post(`${END_POINT}/login`, payload);

};

export {
    login,
}